import React, { useState } from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../../components/Icon";

const Control = ({
	className,
	onEdit,
	onDelete,
	onChangeStatus,
	startTime,
	setStartTime,
}) => {
	const [visibleModal, setVisibleModal] = useState(false);

	const actions = [
		{
			icon: "reload",
			action: onChangeStatus,
		},
		{
			icon: "edit",
			action: () => onEdit(),
		},
		{
			icon: "trash",
			action: onDelete,
		},
	];

	return (
		<>
			<div className={cn(styles.control, className)}>
				{actions.map((x, index) => (
					<button className={styles.button} key={index} onClick={x.action}>
						<Icon
							name={x.icon}
							reicon={x.icon === "reload" && x.icon}
							size="20"
						/>
					</button>
				))}
			</div>
		</>
	);
};

export default Control;
